@if (!isLangLoaded || isNavigationInProgress) {
  <app-loader [isOverlay]="isNavigationInProgress" />
}

<div class="page-wrapper" *ngIf="isLangLoaded">
  <div class="menu-container" [class.menu-container--white]="isWhiteBg">
    <div class="menu-content">
      <main>
        <global-bloomreach-banner-container
          *ngIf="bannerId"
          [id]="bannerId"
        />

        @if (!isMobile) {
          <app-old-browser />
        }

        @if (showHeader) {
          <pac-header
            [isAuthorizedHeaderLocked]="isAuthorizedHeaderLocked"
            [isHeaderNavigationLocked]="isHeaderNavigationLocked"
          />
        }

        <noscript>
          {{ 'error.title.no-js' | translate }}
        </noscript>

        <router-outlet />
      </main>
    </div>
  </div>
</div>
